import { t } from 'i18next';

import { FormSubmissionResTypes, TFormData } from '#/client';
import { createBasicFormConfig } from '#/components/Form';
import Form from '#/components/Form/Form';
import {
  formDataToCreditCard,
  getPaymentInputFields,
} from '#/plugins/paywall/components';

import { PaymentFormProps } from './types';

const PaymentCardForm = ({
  onPurchase,
  isCardRequired,
  buyButtonText = 'web.iap.purchase.button',
  disclaimerText = 'web.iap.disclaimer',
  onSuccess,
  onFailure,
}: PaymentFormProps) => {
  const submitForm = async (formData: TFormData) => {
    const card = formDataToCreditCard(formData);

    return onPurchase({ card })
      .then(() => {
        onSuccess();

        return { _meta: { type: FormSubmissionResTypes.SUCCESS } };
      })
      .catch((err) => {
        onFailure(err);

        return {
          _meta: { type: FormSubmissionResTypes.ERROR, ignoreError: true },
        };
      });
  };

  const inputGroups = createBasicFormConfig(
    'payment',
    getPaymentInputFields(isCardRequired),
    {
      submit: {
        textKeyPath: buyButtonText,
        onClick: submitForm,
        disclaimer: t(disclaimerText),
      },
    }
  );

  return <Form inputGroups={inputGroups} />;
};

export default PaymentCardForm;
